import { defineMessages } from 'react-intl';

export default defineMessages({
  collapse: {
    id: 'frontbucket.search.result.collapse',
    description: 'Collapse the search result',
    defaultMessage: 'Collapse this file',
  },
  expandMatches: {
    id: 'frontbucket.search.result.expand.match',
    description: 'Expand to see all search result matches',
    defaultMessage: 'View all { count } matches in this file',
  },
  expandContext: {
    id: 'frontbucket.search.result.expand.context',
    description: 'Expand the search result context',
    defaultMessage: 'View more lines',
  },
});
